import React from 'react'

function Enrolments() {
  return (
    <div>Enrolments</div>
  )
}

export default Enrolments